export default __webpack_public_path__ + "static/media/Ellipse 92.1775e260.png";